import { render, staticRenderFns } from "./ContainerTypeEditor.vue?vue&type=template&id=126c4a52"
import script from "./ContainerTypeEditor.vue?vue&type=script&lang=js"
export * from "./ContainerTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports